
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.857 12.688c0 .348.136.681.377.928.24.246.568.384.909.384h7.714c.341 0 .668-.138.91-.384.24-.247.376-.58.376-.928V3.5H.857v9.188zm7.286-7c0-.117.045-.228.125-.31a.424.424 0 01.606 0c.08.082.126.193.126.31v6.125a.442.442 0 01-.126.309.424.424 0 01-.606 0 .442.442 0 01-.125-.31V5.689zm-2.572 0c0-.117.046-.228.126-.31a.424.424 0 01.606 0c.08.082.126.193.126.31v6.125a.442.442 0 01-.126.309.424.424 0 01-.606 0 .442.442 0 01-.126-.31V5.689zM3 5.688c0-.117.045-.228.126-.31a.424.424 0 01.606 0c.08.082.125.193.125.31v6.125a.442.442 0 01-.125.309.424.424 0 01-.606 0 .442.442 0 01-.126-.31V5.689zM11.571.875H8.357L8.105.364a.652.652 0 00-.237-.266A.633.633 0 007.53 0H4.468a.626.626 0 00-.338.098.644.644 0 00-.235.266l-.252.511H.429a.424.424 0 00-.303.128.442.442 0 00-.126.31v.875c0 .116.045.227.126.309.08.082.189.128.303.128H11.57a.424.424 0 00.303-.128.442.442 0 00.126-.31v-.874a.442.442 0 00-.126-.31.424.424 0 00-.303-.128z","fill":"#fff"}})])
          )
        }
      }
    